// utils/formValidation.ts

export const zenkakuHankaku = (str: string) =>
  str.replace(/[Ａ-Ｚａ-ｚ０-９！-～]/g, (s) =>
    String.fromCharCode(s.charCodeAt(0) - 0xfee0),
  );

export const isTelValid = (tel: string): boolean => {
  const cleaned = zenkakuHankaku(tel);
  return /^\d{10,11}$/.test(cleaned);
};

export const isNameValid = (name: string): boolean => {
  const cleaned = zenkakuHankaku(name);
  return cleaned.length > 1;
};

export const isEmailValid = (email: string): boolean => {
  const cleaned = zenkakuHankaku(email);
  const VALID_EMAIL_REGEX = /^[\w+\-.]+@[a-z\d\-.]+\.[a-z]+$/i;
  return VALID_EMAIL_REGEX.test(cleaned);
};

export const checkFormStep1 = (
  licenseCheck: string[],
  experienceCheck: string[],
): {
  hasErrors: boolean;
  errorMessage: { license: string; experience: string };
} => {
  const errorMessage = { license: '', experience: '' };
  let hasErrors = false;

  if (licenseCheck.length < 1) {
    errorMessage.license = '＊「お持ちの資格」を少なくとも１つ選択してください';
    hasErrors = true;
  }

  if (experienceCheck.length < 1) {
    errorMessage.experience = '＊「ご経験」を少なくとも１つ選択してください';
    hasErrors = true;
  }

  return { hasErrors, errorMessage };
};

export const checkFormStep2 = (
  desired_workplace_id: number[],
  birth_year: string,
  name: string,
): {
  hasErrors: boolean;
  errorMessage: {
    desired_workplace_id: string;
    birth_year: string;
    name: string;
  };
} => {
  const errorMessage = { desired_workplace_id: '', birth_year: '', name: '' };
  let hasErrors = false;

  if (!desired_workplace_id.length) {
    errorMessage.desired_workplace_id = '＊「都道府県」を選択してください';
    hasErrors = true;
  }

  if (!birth_year) {
    errorMessage.birth_year = '＊「生まれた年」を選択してください';
    hasErrors = true;
  }

  if (!isNameValid(name)) {
    errorMessage.name = '＊「お名前」を入力してください';
    hasErrors = true;
  }

  return { hasErrors, errorMessage };
};

export const checkFormStep3 = (
  email: string,
  tel: string,
): {
  hasErrors: boolean;
  errorMessage: { email: string; tel: string };
} => {
  const errorMessage = { tel: '', email: '' };

  let hasErrors = false;

  if (!isEmailValid(email)) {
    errorMessage.email = '＊正しい「メールアドレス」を入力してください';
    hasErrors = true;
  }

  if (!isTelValid(tel)) {
    errorMessage.tel = '＊10桁か11桁の番号を入力してください';
    hasErrors = true;
  }

  return { hasErrors, errorMessage };
};
